import { render } from "./CustomerDetailsPage.vue?vue&type=template&id=3d893765&scoped=true"
import script from "./CustomerDetailsPage.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsPage.vue?vue&type=script&lang=js"

import "./CustomerDetailsPage.vue?vue&type=style&index=0&id=3d893765&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d893765"]])

export default __exports__